import React from 'react';
function usePhotoIsTacked(): [any, any] {
  const [photoTacked, setPhotoTacked] = React.useState<boolean | undefined>();
  const handlePhotTacked = () => {
    localStorage.setItem('photoTacked', 'photoTacked');
    setPhotoTacked(true);
  };

  React.useEffect(() => {
    const photoFromLocalStorage = localStorage.getItem('photoTacked');
    if (photoFromLocalStorage) {
      setPhotoTacked(true);
    } else {
      setPhotoTacked(false);
    }
  }, [photoTacked, setPhotoTacked]);

  return [photoTacked, handlePhotTacked];
}

export default usePhotoIsTacked;
